import {
  addDoc,
} from "firebase/firestore";
import React, { useState } from "react";
import NavBar from "../components/NavBar";
import { storage } from "../config/firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import LiveFeedItem from "./LiveFeedItem";
import { LiveFeedElement, Team } from "../types";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { getTeamname, livefeedRef, teamRef } from "../utils";
import { PlusCircle } from "phosphor-react";

const Leaderboard = () => {
  const [selectedImage, setSelectedImage] = useState<File | undefined>();
  const [isUploading, setIsUploading] = useState(false);

  const [data] = useCollectionData<LiveFeedElement>(livefeedRef);
  const firebaseLiveFeedElements = data ?? [];

  const [teamData] = useCollectionData<Team>(teamRef);
  const firebaseTeams = teamData ?? [];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fileList = e.target.files;
    if (!fileList) {
      return;
    }
    setSelectedImage(fileList[0]);
  };

  const handleUpload = () => {
    let file = selectedImage;
    if (!file) {
      return;
    }
    const imageRef = ref(storage, file.name);
    uploadBytes(imageRef, file).then((snapshot) => {
      setIsUploading(true);
      getDownloadURL(imageRef).then((url) => {
        addDoc(livefeedRef, {
          text: "Noen lastet opp et bilde!",
          imageUrl: url,
          timestamp: Date.now(),
          type: "IMAGE",
        }).then(() => {
          setSelectedImage(undefined);
          setIsUploading(false);
        })
      });
    });
  };

  return (
    <>
      <NavBar />
      <div className="leaderboard">
          <div className="both-team-points-container">
            {firebaseTeams.map(team => {
              return(
                <div className="individual-team-points-container">
                  <p className="teamname-text">{getTeamname(team.teamName)}</p>
                  <div className="team-points">
                    <p>{team.points}</p>
                  </div>
                </div>
              )
            })}
        </div>
        <div className="livefeed">
          <div className="team-points-header">
            <p>Livefeed</p>
          </div>
          {firebaseLiveFeedElements.sort((a,b) => (b.timestamp - a.timestamp)).map((element,i) => {
            return(
              <LiveFeedItem id={element.timestamp} element={element} hasBackground={i%2===0} />
            )
          })}
        </div>
      </div>
      <div className="absolute-actionbuttons">
          {selectedImage &&
            <button className="button uploadButton" onClick={handleUpload} >
              {isUploading ? "Uploading.." : "Upload"}
            </button>
          }
          <label className="selectFileButton" htmlFor="imageUpload">
            <input  hidden id="imageUpload" type="file" onChange={handleChange} /> 
            <PlusCircle size={70} color="#245633" />
          </label>
        </div>
    </>
  );
};

export default Leaderboard;
